<section>
  <div class="container">
    <div class="columns is-mobile lender-row">
      <div
        class="column is-one-quarter-desktop is-half-touch has-text-centered"
        >
        <ul>
          <li>
            <a
              [href]="listing.form_url"
              target="_blank"
              rel="noopener noreferrer"
              >
              @if (listing.logo_name) {
                <img
                  class="lender-logo"
                  [src]="'/application/views/www/public/assets/img/' + listing.logo_name"
                  [alt]="listing.bank_name"
                  >
              } @else {
                <img
                  class="lender-logo"
                  [src]="s3Logo + '300x100/' + listing.client_id.toLowerCase() + '.png?' + time()"
                  [alt]="listing.bank_name"
                  (error)="getWasabiLogo($event)"
                  >
              }
            </a>
          </li>
          @if (listing.total_reviews != null) {
            <div class="review-total-stars">
              <div class="review-total-stars">
                <li>
                  @for (star of [].constructor(floor(listing.overall_rating)); track $index; let i = $index) {
                    <i class="fas fa-star has-text-link"></i>
                  }
                  @if (floor(listing.overall_rating ) != listing.overall_rating) {
                    <i class="fas fa-star-half-alt has-text-link"></i>
                  }
                  @if (5 - ceil(listing.overall_rating) > 0) {
                    @for (star of [].constructor(5 - ceil(listing.overall_rating)); track $index; let i = $index) {
                      <i class="far fa-star has-text-link"></i>
                    }
                  }
                  <span class="lender-rating tag is-link is-size-7 is-hidden-touch">
                    {{ listing.overall_rating  + ' out of 5' }}
                  </span>
                </li>
                <li class="review-total">
                  @if (listing.total_reviews > 0) {
                    <div>
                      <div class="review-proof">{{ listing.review_source }}</div>
                      {{ listing.total_reviews + ' Verified Reviews' }}
                    </div>
                  } @else {
                    <div>
                      Internal Reviews
                    </div>
                  }
                </li>
              </div>
            </div>
          }
        </ul>
      </div>
      <div
        class="column is-half-touch" style="font-size: 13px; margin-left: 0px;"
        >
        @if (listing.marketing_text) {
          <div>
            <ul>
              @for (text of listing.marketing_text; track text; let i = $index) {
                <li [class]="i >= 2 ? 'is-hidden-touch' : ''">
                  <i class="fas fa-check has-text-link"></i> {{ text }}
                </li>
              }
            </ul>
            @if (listing.form_link) {
              <p class="is-hidden-touch" style="margin-top: 10px">
                <a
                  class="is-uppercase"
                  [href]="listing.form_url"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  {{ 'See ' + listing.bank_name + ' Deal' }}
                  <i class="fas fa-chevron-right"></i>
                </a>
              </p>
            }
            @if (listing.form_link) {
              <a
                class="button is-link is-medium is-hidden-desktop"
                style="margin-bottom: 5px;"
                [href]="listing.form_url"
                target="_blank"
                rel="noopener noreferrer"
                >
                View Rates
                <i class="fas fa-chevron-right" style="margin-left: 5px"></i>
              </a>
            }
            @if (listing.form_link && !isTopTenBestLenders) {
              <div>
                <a
                  class="button is-link is-medium is-hidden-desktop call-btn"
                  [href]="'tel:' + (listing.phone ? listing.phone : officeStatus.phone)"
                  target="_blank"
                  [style.visibility]="officeStatus.answer ? '' : 'hidden'"
                  >
                  Call Us
                </a>
              </div>
            }
          </div>
        }
      </div>
      <div class="column is-one-quarter-desktop has-text-right-desktop has-text-centered-touch is-hidden-touch">
        @if (listing.form_link) {
          <a
            class="button is-link is-medium"
            style="margin-bottom: 5px;"
            [href]="listing.form_url"
            target="_blank"
            rel="noopener noreferrer"
            >
            View Rates
            <i class="fas fa-chevron-right" style="margin-left: 5px"></i>
          </a>
        }
        @if (listing.form_link && !isTopTenBestLenders) {
          <div>
            <a
              class="button is-link is-medium call-btn"
              [href]="'tel:' + (listing.phone ? listing.phone : officeStatus.phone)"
              target="_blank"
              [style.visibility]="officeStatus.answer ? '' : 'hidden'"
              >
              Call Us
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</section>
